import React from 'react'
import { Box, Link, Text } from 'chemistry'

const ConfiguratorBanner = ({ productDetails }) => {
  const { configuratorBanner } = productDetails
  if (!configuratorBanner) return null

  const { img, title, description, linkTitle, inspiration, allowedParams = [] } = configuratorBanner

  if (!img && !title && !description && !linkTitle) return null

  const queryParams = allowedParams.map(p => productDetails[p] && `${p}=${productDetails[p]}`).filter(p => p)
  let link = inspiration
  if (queryParams.length) {
    link = `${inspiration}?${queryParams.join('&')}`
  }

  return (
    <Box className='flex gap-half mb2' backgroundColor='ui-06-lighter'>
      {img && (
        <a href={link}>
          <img src={img} alt='configurator_image' width='90px' />
        </a>
      )}
      <Box className='flex flex-column justify-center' mb='15' mt='10px'>
        {title && (
          <Text
            as='h3'
            fontSize='20px'
            fontFamily='bold'
            fontWeight={500}
            lineHeight={1.4}
            my={0}
            color='primary-01-gray'
          >
            {title}
          </Text>
        )}
        {description && (
          <Text as='h5' fontSize='14px' fontWeight={100} lineHeight='1.4' my={0}>
            {description}
          </Text>
        )}
        {linkTitle && (
          <Link href={link} mt='auto' color='primary-02-red'>
            {linkTitle}
          </Link>
        )}
      </Box>
    </Box>
  )
}

export default ConfiguratorBanner
